var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgYoutube(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.81 7.855C28.0505 6.504 27.2262 6.2555 25.548 6.161C23.8715 6.04725 19.6558 6 16.0035 6C12.3442 6 8.12675 6.04725 6.452 6.15925C4.77725 6.2555 3.95125 6.50225 3.18475 7.855C2.4025 9.20425 2 11.5283 2 15.6198V15.6337C2 19.7078 2.4025 22.0492 3.18475 23.3845C3.95125 24.7355 4.7755 24.9805 6.45025 25.0942C8.12675 25.1923 12.3442 25.25 16.0035 25.25C19.6558 25.25 23.8715 25.1922 25.5497 25.096C27.228 24.9823 28.0522 24.7373 28.8118 23.3863C29.601 22.051 30 19.7095 30 15.6355V15.6268V15.6215C30 11.5283 29.601 9.20425 28.81 7.855ZM12.5 20.875V10.375L21.25 15.625L12.5 20.875Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutube);
export default __webpack_public_path__ + "static/media/youtube.aefd16e21301dc236ad6b9173d5ff8b2.svg";
export { ForwardRef as ReactComponent };